export const patterns: {
  LatinAndCyrylicName: RegExp;
  LatinAndCyrylicText: RegExp;
  PLNameValidator: RegExp;
  PLTextValidator: RegExp;
  CandidateNameValidator: RegExp;
  CandidateNameCharacterValidator: RegExp;
  DateValidator: RegExp;
  ZipValidator: RegExp;
  CommentTextValidator: RegExp;
  VisitDateValidator: RegExp;
  HasUpperCaseLetter: RegExp;
  HasSpecialCharacter: RegExp;
  PhoneNumberValidator: RegExp;
  NumbersLettersHyphenWhiteSpaceParens: RegExp;
} = {
  LatinAndCyrylicName:
    /^[ \-A-Za-z0-9AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻżQqXxVv'"\p{sc=Cyrillic}]+$/u,
  LatinAndCyrylicText:
    /^[ \n\-A-Za-z0-9AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻżQqXxVv'",.?:/+\p{sc=Cyrillic}]+$/u,
  PLNameValidator: /^[ \-A-Za-z0-9AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻżQqXxVv'"]+$/,
  PLTextValidator: /^[ \n\-A-Za-z0-9AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻżQqXxVv'",.?:/+]+$/,
  CandidateNameValidator: /^[\p{Zs}A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż'`-]+$/u,
  CandidateNameCharacterValidator: /[\p{Zs}A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż'`-]/u,
  PhoneNumberValidator: /^[ \n0-9\-\+]+$/,
  CommentTextValidator:
    /^[ \S\r\n\-A-Za-z0-9AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻżQqXxVv'",.?;:/!@#$%^&*\(\)_+=\[\]]+$/,
  DateValidator:
    /^(((0[1-9]|[12]\d|3[01])\.(0[13578]|1[02])\.((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\.(0[13456789]|1[012])\.((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\.02\.((19|[2-9]\d)\d{2}))|(29\.02\.((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/,
  ZipValidator: /^[0-9][0-9][0-9][0-9][0-9]$/,
  VisitDateValidator: /^[0-9/.]+$/,
  HasUpperCaseLetter: /[A-Z]/,
  HasSpecialCharacter: /[!@#$%^&*()_+\-\?.]/,
  NumbersLettersHyphenWhiteSpaceParens: /^[0-9A-Za-z\-  ()]+$/,
};
